import React from 'react';

import { UploadButton } from './upload-button';
import { Upload } from '../../../components/icons/CloudForSelectingFile';

import styles from './FileDropzone.module.scss';
type DropFileForAddProps = {
  handleSubmitFile: (files: File[]) => Promise<void>;
};

export const FileDropzone: React.FC<DropFileForAddProps> = ({ handleSubmitFile }) => (
  <div style={{ height: '100%', flexGrow: 1, padding: '1.6rem' }}>
    <div className={styles['container']}>
      <Upload />

      <div className={styles['title']}>Select file(s) or drag and drop here</div>

      <UploadButton text="Select file(s)" onUploadFileValue={handleSubmitFile} multiple />
    </div>
  </div>
);
